import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text'
import { SeFeFormServiceModule } from 'se-fe-form-service'
import { SeFeHeaderModule } from 'se-fe-header'
import { seFeIconCheckCircle, seFeIconCopy, SeFeIconModule, seFeIconWarning } from 'se-fe-icon'
import { SeFeSpinnerModule } from 'se-fe-spinner'
import { SeFeTranslationsModule } from 'se-fe-translations'
import { SeFeToastModule } from 'se-fe-toast'
import { SeFeTooltipModule } from 'se-fe-tooltip'
import { MfaAppCodesComponent } from './mfa-app-codes/mfa-app-codes.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeButtonModule,
    SeFeFormFieldTextModule,
    SeFeFormServiceModule,
    SeFeHeaderModule,
    SeFeIconModule.include([seFeIconCheckCircle, seFeIconCopy, seFeIconWarning]),
    SeFeSpinnerModule,
    SeFeToastModule,
    SeFeTooltipModule,
    SeFeTranslationsModule,
  ],
  declarations: [MfaAppCodesComponent],
  exports: [MfaAppCodesComponent],
})
export class SeHouseholdSetupFeatureMfaAppCodesModule { }
